const { metrics } = require('lib/radio')


let install_promise = null
const listeners = []
const zendesk_key = '1551defd-d100-435c-a5ac-33e760e55a97'

function openHandler() {
    listeners.forEach((listener) => {
        listener()
    })
}

module.exports = {
    install() {
        // If it's done installing return
        if (window.zE) return

        // If it's still installing return the cached promise
        if (install_promise) return install_promise

        install_promise = new Promise((resolve, reject) => {
            const s = document.createElement('script')
            s.setAttribute('id', 'ze-snippet')
            s.setAttribute('src', `https://static.zdassets.com/ekr/snippet.js?key=${zendesk_key}`)
            document.body.appendChild(s)
            s.onload = () => {
                if (window.zE) {
                    window.zE('webWidget:on', 'open', openHandler)
                    resolve()
                } else {
                    reject(new Error('Zendesk widget install failed.'))
                }
            }
        })

        return install_promise
    },

    isInstalled() {
        return !!window.zE || !!install_promise
    },

    api(...args) {
        if (__DEBUG__) {
            if (typeof window === 'undefined') throw new Error('Zendesk widget must be called in browser context.')

            if (!this.isInstalled()) throw new Error('Zendesk widget is not installed.')
        }

        // Call the action after install is done
        return install_promise && install_promise.then(() => window.zE.apply(window.zE, args))
    },

    track(from) {
        if (__DEBUG__ && !from) throw new Error('Zendesk track requires from.')

        const sendMetric = () => {
            metrics.trigger('beacon:open', { from })
        }

        listeners.push(sendMetric)

        return () => {
            listeners.splice(listeners.indexOf(sendMetric), 1)
        }
    },
}
